import { NotifyHelper } from "../../../helpers/toast";
import { objFormDefine } from "../../action-types/form/IFormActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const formActions = {
    ...generateActions(objFormDefine, "FORM"),
    ...generateActionForKey(objFormDefine, "FORM",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormDefine, "FORM",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objFormDefine, "FORM",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormDefine, "FORM",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objFormDefine, "FORM",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormDefine, "FORM",
        "LOCK_SUCESS", (m: any) => NotifyHelper.Success("Locked")),
    ...generateActionForKey(objFormDefine, "FORM",
        "LOCK_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormDefine, "FORM",
        "UNLOCK_SUCESS", (m: any) => NotifyHelper.Success("Unlocked")),
    ...generateActionForKey(objFormDefine, "FORM",
        "UNLOCK_ERROR", (m: any) => NotifyHelper.Error(m))
}
